import jwtDecode from 'jwt-decode';

const buildAuthUserFromSSOTokens = ssoTokens => {
    const { accessToken, idToken } = ssoTokens;
    const idTokenDecoded = jwtDecode(idToken);
    const accessTokenDecoded = accessToken && jwtDecode(accessToken);

    const pk = idTokenDecoded['custom:UserId'] || (accessTokenDecoded && accessTokenDecoded.username) || idTokenDecoded.preferred_username;
    const username = (accessToken && accessToken.username) || idTokenDecoded.preferred_username;

    return {
        pk,
        subscriberPk:  idTokenDecoded['custom:SubscriberId'],
        userType: idTokenDecoded['custom:UserType'],
        email: idTokenDecoded.email,
        username,
        auth: {
            accessToken,
            idToken,
            refreshToken: null,
            expiry: (accessToken && accessTokenDecoded.exp) || idTokenDecoded.exp,
        },
    };
};

export default buildAuthUserFromSSOTokens;